import React, { Component } from 'react';
import graphql from 'babel-plugin-relay/macro';
import { QueryRenderer } from 'react-relay';
import { Redirect } from 'react-router-dom';
import AbEnvironment from '../auth/AbEnvironment';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import { Checkbox, FormControlLabel, FormGroup, Link, Switch, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import ServerError from '../ui/ServerError';
import LoadingSpinner from '../ui/LoadingSpinner';
//import SearchField from '../ui/SearchField';

const abEnvironment = new AbEnvironment();
const AdminResellerReportQuery = graphql`
query AdminResellerReportQuery($startts: Datetime, $endts: Datetime, $first: Int) {
  resellerreport2(startts: $startts, endts: $endts, first: $first) {
    totalCount
    nodes {
      starttime
      endtime
      accountId
      resellerName
      subsActive
      subsBilled
      billing
      payment
      custs
      custsSubsActive
      custsSubsBilled
      custsBilling
      custsPayment
      totalPayment
    }
  }
}
`;

const styleSheet = theme => ({
    root: {
      flexGrow: 1,
      marginTop: 10,
    },
    tabroot: {
      flexGrow: 1,
      margin: 10,
      width: '100%',
    },
    flex: {
      flex: 1,
    },
    paper1: {
      padding: 16,
      textAlign: 'center',
      color: theme.palette.text.secondary,
    },
    paper2: {
      padding: 12,
      textAlign: 'left',
      color: theme.palette.text.secondary,
    },
    container: {
      display: 'flex',
      flexWrap: 'wrap',
    },
    formControl: {
      margin: 'theme.spacing(1)',
    },
    textField: {
      margin: 'theme.spacing(1)',
      marginBottom: 6,
    },
    textFieldAddress: {
      margin: 'theme.spacing(1)',
    },
    titleContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    statusdiv: {
      display: 'flex',
      alignItems: 'center',
      direction: 'row',
      justify: 'center',
    },
    statusicon: {
      width: 52,
      height: 52,
      color: 'green',
    },
    erroricon: {
      width: 52,
      height: 52,
      color: 'red',
    },
    tblCellB: {
        backgroundColor: '#E0FFFF',
    },
});

class AdminResellerReport extends Component {
  state = {
    a_saA: false,
    a_saB: true,
    a_saas: false,
    a_paid: false,
    a_cc: true,
    a_csa: false,
    a_csb: true,
    a_csaas: false,
    a_cpaid: false,
    a_tpaid: true,
    only_show_transacted: 1,
  };

  handleCheckChange = name => event => {
    // If there is only one thing checked, and it would be
    // unchecked, set everything to be checked
    let numChecks = this.numberOfChecks();
    if (numChecks === 1 && event.target.checked === false) {
      this.setState({
        a_saA:   true,
        a_saB:   true,
        a_saas:  true,
        a_paid:  true,
        a_cc:    true,
        a_csa:   true,
        a_csb:   true,
        a_csaas: true,
        a_cpaid: true,
        a_tpaid: true,
      });

    } else {
      this.setState({
        [name]: event.target.checked,
      });
    }
  };

  goTo(route) {
    this.props.history.push(`/${route}`);
  }

  numberOfChecks() {
    let num = 0;

    if (this.state.a_saA)
      num++;

    if (this.state.a_saB)
      num++;

    if (this.state.a_saas)
      num++;

    if (this.state.a_paid)
      num++;

    if (this.state.a_cc)
      num++;

    if (this.state.a_csa)
      num++;

    if (this.state.a_csb)
      num++;

    if (this.state.a_csaas)
      num++;

    if (this.state.a_cpaid)
      num++;

    if (this.state.a_tpaid)
      num++;

    return num;
  }
    
  render() {
    const { isAuthenticatedAppBind, logError } = this.props.auth;
    const classes = this.props.classes;

    if (isAuthenticatedAppBind()) {
      return  (
        <div>
          <FormGroup row>
            <FormControlLabel
              control={ <Checkbox checked={this.state.a_saA} onChange={this.handleCheckChange('a_saA')} value={this.state.a_saA} /> }
              label="SA (Reseller active subscriptions)"
            />
            <FormControlLabel
              control={ <Checkbox checked={this.state.a_saB} onChange={this.handleCheckChange('a_saB')} value={this.state.a_saB} /> }
              label="SB (Reseller billed subscriptions)"
            />
            <FormControlLabel
              control={ <Checkbox checked={this.state.a_saas} onChange={this.handleCheckChange('a_saas')} value={this.state.a_saas} /> }
              label="SaaS (SaaS charges - reseller)"
            />
            <FormControlLabel
              control={ <Checkbox checked={this.state.a_paid} onChange={this.handleCheckChange('a_paid')} value={this.state.a_paid} /> }
              label="Paid (Reseller paid)"
            />
            <FormControlLabel
              control={ <Checkbox checked={this.state.a_cc} onChange={this.handleCheckChange('a_cc')} value={this.state.a_cc} /> }
              label="Custs (# of customers)"
            />
            <FormControlLabel
              control={ <Checkbox checked={this.state.a_csa} onChange={this.handleCheckChange('a_csa')} value={this.state.a_csa} /> }
              label="CSA (Customer active subscriptions)"
            />
            <FormControlLabel
              control={ <Checkbox checked={this.state.a_csb} onChange={this.handleCheckChange('a_csb')} value={this.state.a_csb} /> }
              label="CSB (Customer billed subscriptions)"
            />
            <FormControlLabel
              control={ <Checkbox checked={this.state.a_csaas} onChange={this.handleCheckChange('a_csaas')} value={this.state.a_csaas} /> }
              label="CSaaS (SaaS charges - customer)"
            />
            <FormControlLabel
              control={ <Checkbox checked={this.state.a_cpaid} onChange={this.handleCheckChange('a_cpaid')} value={this.state.a_cpaid} /> }
              label="CPaid (Customer paid)"
            />
            <FormControlLabel
              control={ <Checkbox checked={this.state.a_tpaid} onChange={this.handleCheckChange('a_tpaid')} value={this.state.a_tpaid} /> }
              label="TPaid (Total paid)"
            />
            <FormControlLabel
              control={
                <Switch
                  checked={this.state.only_show_transacted === 1}
                  onChange={(e, checked) => {
                    if (this.state.only_show_transacted === 1) {
                      this.setState({ only_show_transacted: 0});
                    } else {
                      this.setState({ only_show_transacted: 1});
                    }
                  }}
                />
                }
              label="Only show resellers that have transacted"
            />

          </FormGroup>
          <QueryRenderer
            environment={abEnvironment.getEnvironment()}
            query={AdminResellerReportQuery}
            variables={{startts: '2019-10-01', endts: null, first: 2000}}
            render={({error, props})=> {
              if (error) {
                logError(error.message);
                return (
                  <ServerError/>
                );
              } else if (props) {
                let nodes = props.resellerreport2.nodes;

                // Iterate the nodes for the first period to setup the column information
                let monthlyColumns = [];
                let summaryColumn = null;
                let tempColumn = null;

                let j=0;
                let ii=0;
                for (let i=0; i<nodes.length; i++) {
                  if (i === 0) {
                    // First node - setup
                    tempColumn = [];
                    tempColumn.push(nodes[i]);
                  } else {
                    if (nodes[i].endtime !== nodes[i-1].endtime) {
                      if (j === 0) {
                        summaryColumn = tempColumn;
                      } else {
                        monthlyColumns.push(tempColumn);
                      }
                      tempColumn = [];
                      j++;
                      ii=0;

                      // Edge case - do we need a placeholder?  On the next row
                      // - so need to add placeholders until a match is found.
                      let haveMatch = true;
                      while (nodes[i].resellerName !== summaryColumn[ii].resellerName) {
                        let noDataNode = {
                          starttime:       nodes[i].starttime,
                          endtime:         nodes[i].endtime,
                          accountId:       summaryColumn[ii].accountId,
                          resellerName:    summaryColumn[ii].resellerName,
                          subsActive:      0,
                          subsBilled:      0,
                          billing:         0.00,
                          payment:         0.00,
                          custs:           0,
                          custsSubsActive: 0,
                          custsSubsBilled: 0,
                          custsBilling:    0.00,                   
                          custsPayment:    0.00,                   
                          totalPayment:    0.00                  
                        };
                        tempColumn.push(noDataNode);
                        ii++;
                        
                        // Boundary - should not happen
                        if (ii >= summaryColumn.length) {
                          haveMatch = false;
                          break;
                        }
                      }
                      if (haveMatch) {
                        tempColumn.push(nodes[i]);
                        ii++;
                      }
                    } else {
                      if (j === 0) {
                        tempColumn.push(nodes[i]);
                      } else {
                        let haveMatch = true;
                        while (nodes[i].resellerName !== summaryColumn[ii].resellerName) {
                          let noDataNode = {
                            starttime:       nodes[i].starttime,
                            endtime:         nodes[i].endtime,
                            accountId:       summaryColumn[ii].accountId,
                            resellerName:    summaryColumn[ii].resellerName,
                            subsActive:      0,
                            subsBilled:      0,
                            billing:         0.00,
                            payment:         0.00,
                            custs:           0,
                            custsSubsActive: 0,
                            custsSubsBilled: 0,
                            custsBilling:    0.00,                   
                            custsPayment:    0.00,                   
                            totalPayment:    0.00                  
                            };
                          tempColumn.push(noDataNode);
                          ii++;
                            
                          // Boundary - should not happen
                          if (ii >= summaryColumn.length) {
                            haveMatch = false;
                            break;
                          }
                        }
                        if (haveMatch) {
                            tempColumn.push(nodes[i]);
                            ii++;
                        }
                      }
                    }
                  }
                }

                if (tempColumn != null && tempColumn.length > 0) {
                  monthlyColumns.push(tempColumn);
                }

                // Based on what is only_show_transacted, determine if rows should be removed.
                if (this.state.only_show_transacted === 1 && summaryColumn != null && summaryColumn.length > 0) {
                  let rowsToRemove = [];
                  for (let i=0; i< summaryColumn.length; i++) {
                    let anode = summaryColumn[i];
                    let removeRow = true;

                    /*
                    if (this.state.a_saA && anode.subsActive > 0)
                      removeRow = false; 
                    if (this.state.a_saB && anode.subsBilled > 0)
                      removeRow = false; 
                    if (this.state.a_saas && Number(anode.billing) > 0)
                      removeRow = false; 
                    if (this.state.a_paid && Number(anode.payment) > 0)
                      removeRow = false; 
                    if (this.state.a_cc && anode.custs > 0)
                      removeRow = false; 
                    if (this.state.a_csa && anode.custsSubsActive > 0)
                      removeRow = false; 
                    if (this.state.a_csb && anode.custsSubsBilled > 0)
                      removeRow = false; 
                    if (this.state.a_csaas && Number(anode.custsBilling) > 0)
                      removeRow = false; 
                    if (this.state.a_cpaid && Number(anode.custsPayment) > 0)
                      removeRow = false;
                    if (this.state.a_tpaid && Number(anode.totalPayment) > 0)
                      removeRow = false; 
                    */
                    if (Number(anode.totalPayment) > 0)
                      removeRow = false;

                    if (removeRow) {
                      rowsToRemove.push(i);
                    }
                  }

                  if (rowsToRemove.length > 1) {
                    // Remove from summary
                    for (let rr=rowsToRemove.length-1; rr>=0; rr--) {
                      summaryColumn.splice(rowsToRemove[rr], 1);
                    }

                    // Remove from the monthlies
                    for (let j=0; j<monthlyColumns.length; j++) {
                      for (let rr=rowsToRemove.length-1; rr>=0; rr--) {
                        monthlyColumns[j].splice(rowsToRemove[rr], 1);
                      }
                    }
                  }
                }

                let theRow = -1;
                let bgc = false;
                return (
                  <div className={classes.root}>
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell>Reseller</TableCell>
                          {monthlyColumns.map(col => {
                            let theStart = "" + col[0].starttime;
                            bgc = ! bgc;

                            if (bgc) {
                              return(
                                <TableCell className={classes.tblCellB} align="center" colspan={this.numberOfChecks()}>{theStart.substring(0,7)}</TableCell>
                              );
                            } else {
                              return(
                                <TableCell align="center" colspan={this.numberOfChecks()}>{theStart.substring(0,7)}</TableCell>
                              );
                            }
                          })}
                          {! bgc  && <TableCell className={classes.tblCellB} align="center" colspan={this.numberOfChecks()}>Total</TableCell>}
                          {bgc && <TableCell align="center" colspan={this.numberOfChecks()}>Total</TableCell>}
                        </TableRow>
                        <TableRow>
                          <TableCell/>
                          {monthlyColumns.map(col => {
                            bgc = ! bgc;
                            if (bgc) {
                              return(
                                <React.Fragment>
                                  {this.state.a_saA && <TableCell className={classes.tblCellB} align="right">SA</TableCell>}
                                  {this.state.a_saB && <TableCell className={classes.tblCellB} align="right">SB</TableCell>}
                                  {this.state.a_saas && <TableCell className={classes.tblCellB} align="right">SaaS</TableCell>}
                                  {this.state.a_paid && <TableCell className={classes.tblCellB} align="right">Paid</TableCell>}
                                  {this.state.a_cc && <TableCell className={classes.tblCellB} align="right">Custs</TableCell>}
                                  {this.state.a_csa && <TableCell className={classes.tblCellB} align="right">CSA</TableCell>}
                                  {this.state.a_csb && <TableCell className={classes.tblCellB} align="right">CSB</TableCell>}
                                  {this.state.a_csaas && <TableCell className={classes.tblCellB} align="right">CSaaS</TableCell>}
                                  {this.state.a_cpaid && <TableCell className={classes.tblCellB} align="right">CPaid</TableCell>}
                                  {this.state.a_tpaid && <TableCell className={classes.tblCellB} align="right">TPaid</TableCell>}
                                </React.Fragment>
                              );
                            } else {
                              return(
                                <React.Fragment>
                                  {this.state.a_saA && <TableCell align="right">SA</TableCell>}
                                  {this.state.a_saB && <TableCell align="right">SB</TableCell>}
                                  {this.state.a_saas && <TableCell align="right">SaaS</TableCell>}
                                  {this.state.a_paid && <TableCell align="right">Paid</TableCell>}
                                  {this.state.a_cc && <TableCell align="right">Custs</TableCell>}
                                  {this.state.a_csa && <TableCell align="right">CSA</TableCell>}
                                  {this.state.a_csb && <TableCell align="right">CSB</TableCell>}
                                  {this.state.a_csaas && <TableCell align="right">CSaaS</TableCell>}
                                  {this.state.a_cpaid && <TableCell align="right">CPaid</TableCell>}
                                  {this.state.a_tpaid && <TableCell align="right">TPaid</TableCell>}
                                </React.Fragment>
                              );
                            }
                          })}
                          {! bgc &&
                          <React.Fragment>
                            {this.state.a_saA && <TableCell className={classes.tblCellB} align="right">SA</TableCell>}
                            {this.state.a_saB && <TableCell className={classes.tblCellB} align="right">SB</TableCell>}
                            {this.state.a_saas && <TableCell className={classes.tblCellB} align="right">SaaS</TableCell>}
                            {this.state.a_paid && <TableCell className={classes.tblCellB} align="right">Paid</TableCell>}
                            {this.state.a_cc && <TableCell className={classes.tblCellB} align="right">Custs</TableCell>}
                            {this.state.a_csa && <TableCell className={classes.tblCellB} align="right">CSA</TableCell>}
                            {this.state.a_csb && <TableCell className={classes.tblCellB} align="right">CSB</TableCell>}
                            {this.state.a_csaas && <TableCell className={classes.tblCellB} align="right">CSaaS</TableCell>}
                            {this.state.a_cpaid && <TableCell className={classes.tblCellB} align="right">CPaid</TableCell>}
                            {this.state.a_tpaid && <TableCell className={classes.tblCellB} align="right">TPaid</TableCell>}
                          </React.Fragment>
                          }
                          {bgc &&
                          <React.Fragment>
                            {this.state.a_saA && <TableCell align="right">SA</TableCell>}
                            {this.state.a_saB && <TableCell align="right">SB</TableCell>}
                            {this.state.a_saas && <TableCell align="right">SaaS</TableCell>}
                            {this.state.a_paid && <TableCell align="right">Paid</TableCell>}
                            {this.state.a_cc && <TableCell align="right">Custs</TableCell>}
                            {this.state.a_csa && <TableCell align="right">CSA</TableCell>}
                            {this.state.a_csb && <TableCell align="right">CSB</TableCell>}
                            {this.state.a_csaas && <TableCell align="right">CSaaS</TableCell>}
                            {this.state.a_cpaid && <TableCell align="right">CPaid</TableCell>}
                            {this.state.a_tpaid && <TableCell align="right">TPaid</TableCell>}
                          </React.Fragment>
                          }
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {summaryColumn.map(anode => {
                          theRow++;
                          bgc = false;

                          let s_saV = 0;
                          let s_saB = 0;
                          let s_saas = 0;
                          let s_paid = 0;
                          let s_cc  = 0;
                          let s_csa = 0;
                          let s_csb = 0;
                          let s_csaas = 0;
                          let s_cpaid = 0;
                          let s_tpaid = 0;
                          
                          let s_href = 'reseller?accountId=' + anode.accountId + '&fp=Report';

                          s_saV = anode.subsActive;
                          s_saB = anode.subsBilled;
                          s_saas = Number(anode.billing)
                          .toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});
                          s_paid = Number(anode.payment)
                          .toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});
                          s_cc = anode.custs;
                          s_csa = anode.custsSubsActive;
                          s_csb = anode.custsSubsBilled;
                          s_csaas = Number(anode.custsBilling)
                          .toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});
                          s_cpaid = Number(anode.custsPayment)
                          .toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});
                          s_tpaid = Number(anode.totalPayment)
                          .toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});

                          return(
                            <TableRow>
                              <TableCell>
                                <Link variant="body2" onClick={this.goTo.bind(this, s_href)}>
                                  {anode.resellerName}
                                </Link>
                              </TableCell>
                              {monthlyColumns.map(col => {
                                bgc = ! bgc;
                                let saV = 0;
                                let saB = 0;
                                let saas = 0;
                                let paid = 0;
                                let cc  = 0;
                                let csa = 0;
                                let csb = 0;
                                let csaas = 0;
                                let cpaid = 0;
                                let tpaid = 0;

                                if (col.length > theRow) {
                                  saV = col[theRow].subsActive;
                                  saB = col[theRow].subsBilled;
                                  saas = Number(col[theRow].billing)
                                  .toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});
                                  paid = Number(col[theRow].payment)
                                  .toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});
                                  cc = col[theRow].custs;
                                  csa = col[theRow].custsSubsActive;
                                  csb = col[theRow].custsSubsBilled;
                                  csaas = Number(col[theRow].custsBilling)
                                  .toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});
                                  cpaid = Number(col[theRow].custsPayment)
                                  .toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});
                                  tpaid = Number(col[theRow].totalPayment)
                                  .toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});
                                }

                                if (bgc) {
                                  return (
                                    <React.Fragment>
                                    {this.state.a_saA   && <TableCell className={classes.tblCellB} align="right">{saV}</TableCell>}
                                    {this.state.a_saB   && <TableCell className={classes.tblCellB} align="right">{saB}</TableCell>}
                                    {this.state.a_saas  && <TableCell className={classes.tblCellB} align="right">{saas}</TableCell>}
                                    {this.state.a_paid  && <TableCell className={classes.tblCellB} align="right">{paid}</TableCell>}
                                    {this.state.a_cc    && <TableCell className={classes.tblCellB} align="right">{cc}</TableCell>}
                                    {this.state.a_csa   && <TableCell className={classes.tblCellB} align="right">{csa}</TableCell>}
                                    {this.state.a_csb   && <TableCell className={classes.tblCellB} align="right">{csb}</TableCell>}
                                    {this.state.a_csaas && <TableCell className={classes.tblCellB} align="right">{csaas}</TableCell>}
                                    {this.state.a_cpaid && <TableCell className={classes.tblCellB} align="right">{cpaid}</TableCell>}
                                    {this.state.a_tpaid && <TableCell className={classes.tblCellB} align="right">{tpaid}</TableCell>}
                                    </React.Fragment>
                                  );
                                } else {
                                  return (
                                    <React.Fragment>
                                    {this.state.a_saA   && <TableCell align="right">{saV}</TableCell>}
                                    {this.state.a_saB   && <TableCell align="right">{saB}</TableCell>}
                                    {this.state.a_saas  && <TableCell align="right">{saas}</TableCell>}
                                    {this.state.a_paid  && <TableCell align="right">{paid}</TableCell>}
                                    {this.state.a_cc    && <TableCell align="right">{cc}</TableCell>}
                                    {this.state.a_csa   && <TableCell align="right">{csa}</TableCell>}
                                    {this.state.a_csb   && <TableCell align="right">{csb}</TableCell>}
                                    {this.state.a_csaas && <TableCell align="right">{csaas}</TableCell>}
                                    {this.state.a_cpaid && <TableCell align="right">{cpaid}</TableCell>}
                                    {this.state.a_tpaid && <TableCell align="right">{tpaid}</TableCell>}
                                    </React.Fragment>
                                  );
                                }
                              })}

                              {! bgc &&
                                <React.Fragment>
                                {this.state.a_saA   && <TableCell className={classes.tblCellB} align="right">{s_saV}</TableCell>}
                                {this.state.a_saB   && <TableCell className={classes.tblCellB} align="right">{s_saB}</TableCell>}
                                {this.state.a_saas  && <TableCell className={classes.tblCellB} align="right">{s_saas}</TableCell>}
                                {this.state.a_paid  && <TableCell className={classes.tblCellB} align="right">{s_paid}</TableCell>}
                                {this.state.a_cc    && <TableCell className={classes.tblCellB} align="right">{s_cc}</TableCell>}
                                {this.state.a_csa   && <TableCell className={classes.tblCellB} align="right">{s_csa}</TableCell>}
                                {this.state.a_csb   && <TableCell className={classes.tblCellB} align="right">{s_csb}</TableCell>}
                                {this.state.a_csaas && <TableCell className={classes.tblCellB} align="right">{s_csaas}</TableCell>}
                                {this.state.a_cpaid && <TableCell className={classes.tblCellB} align="right">{s_cpaid}</TableCell>}
                                {this.state.a_tpaid && <TableCell className={classes.tblCellB} align="right">{s_tpaid}</TableCell>}
                                </React.Fragment>
                              }
                              {bgc &&
                                <React.Fragment>
                                {this.state.a_saA   && <TableCell align="right">{s_saV}</TableCell>}
                                {this.state.a_saB   && <TableCell align="right">{s_saB}</TableCell>}
                                {this.state.a_saas  && <TableCell align="right">{s_saas}</TableCell>}
                                {this.state.a_paid  && <TableCell align="right">{s_paid}</TableCell>}
                                {this.state.a_cc    && <TableCell align="right">{s_cc}</TableCell>}
                                {this.state.a_csa   && <TableCell align="right">{s_csa}</TableCell>}
                                {this.state.a_csb   && <TableCell align="right">{s_csb}</TableCell>}
                                {this.state.a_csaas && <TableCell align="right">{s_csaas}</TableCell>}
                                {this.state.a_cpaid && <TableCell align="right">{s_cpaid}</TableCell>}
                                {this.state.a_tpaid && <TableCell align="right">{s_tpaid}</TableCell>}
                                </React.Fragment>
                               }
                            </TableRow>
                          );

                        })}
                        <TableCell></TableCell>    
                      </TableBody>
                    </Table>
                  </div>
                );
              }
              return <div><LoadingSpinner/></div>
            }}
          />
        </div>
      );
              
    } else {
      return (
        <Redirect to='/home' />
      );
    }    
  }
}

AdminResellerReport.propTypes = {
  classes: PropTypes.object.isRequired,
};
      
export default withStyles(styleSheet)(AdminResellerReport);
